import React from "react";
import Head from "next/head";
import {
  ChakraProvider,
  Box,
  Heading,
  Text,
  Link,
  useColorModeValue,
  VStack,
  Image,
  Button,
} from "@chakra-ui/react";
import { motion } from "framer-motion";

export const UnauthorizedView: React.FC = () => {
  const unauthorizedBgColor = useColorModeValue("#d1dbdb", "gray.800");
  const unauthorizedBoxBgColor = useColorModeValue("white", "gray.700");
  const buttonBgColor = useColorModeValue("#000000", "black");
  const buttonHoverBgColor = useColorModeValue("#000000", "black.600");

  return (
    <>
      <Head>
        <title>Loma AI</title>
        <meta
          name="Create Business Idea"
          content="Loma AI - Create Business Idea"
        />
        <link
          rel="icon"
          href="https://loma-files.s3.us-west-1.amazonaws.com/favicons/favicon.ico"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap"
          rel="stylesheet"
        />
      </Head>
      <ChakraProvider>
        <Box
          minHeight="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg={unauthorizedBgColor}
          p={4}
        >
          <Box
            as={motion.div}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: "0.5s" }}
            p={8}
            bg={unauthorizedBoxBgColor}
            borderRadius="lg"
            boxShadow="xl"
            textAlign="center"
            maxW="md"
            w="full"
          >
            <VStack spacing={6}>
              <Image
                src="https://loma-files.s3.us-west-1.amazonaws.com/loma-logos/social-media-kit/Icon10.jpg"
                w={100}
                h={100}
                mb={2}
                borderRadius="md"
                boxShadow="lg"
              />
              <Heading size="xl" mb={2}>
                Welcome to Loma
              </Heading>
              <Text fontSize="lg" color="gray.600">
                We're currently in private beta. To get early access and start
                building your business idea, please contact us.
              </Text>
              <Button
                as={Link}
                href="mailto:contact@withloma.com?subject=Loma%20AI%20-%20Request%20Early%20Access"
                size="lg"
                bg={buttonBgColor}
                color="white"
                _hover={{ bg: buttonHoverBgColor }}
                borderRadius="lg"
                px={8}
                mt={4}
              >
                Request Access
              </Button>
            </VStack>
          </Box>
        </Box>
      </ChakraProvider>
    </>
  );
};
